import { gql } from '@apollo/client';

const FUND = gql`
  query GetFund($id: UUID!) {
    fund(id: $id) {
      id
      bookValue
      currency
      grossIrr
      grossMultiple
      investedCapital
      realizedValue
    }
  }
`;

const GET_FUNDS = gql`
  query GetFund {
    funds {
      id
      name
      isSubfund
      subfunds {
        id
        name
      }
      parentFund {
        id
        name
      }
      currency
    }
  }
`;

const GET_FUND_NAME = gql`
  query GetFundName($id: UUID!) {
    fund(id: $id) {
      id
      name
      currency
    }
  }
`;

export { FUND, GET_FUNDS, GET_FUND_NAME };
